export const link = (state = null, action) => {
    switch (action.type) {
        case 'LINK':
            return action.link;
        default:
            return state
    }
};
